module.exports = __webpack_public_path__ + "img/BAU Seniors_17.4cefd054.jpg";